import circleCross from './svg/circle-cross.svg?raw';
import attach1 from './svg/attach.svg?raw';
import close from './svg/close.svg?raw';
import progress1 from './svg/progress.svg?raw';
import reportBack from './svg/report-back.svg?raw';

export const ASSETS = {
  closeCircle: circleCross,
  attach: attach1,
  closeCross: close,
  progress: progress1,
  back: reportBack,
};
